export default __webpack_public_path__ + "static/media/map_menu_item.eaf77b3e.svg";